import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const AppPreset = definePreset(Aura, {
	//Your customizations, see the following sections for examples
	semantic: {
		primary: {
			50: '#ffffff',
			100: '#ffffff',
			200: '#20346d',
			300: '#20346d',
			400: '#20346d',
			500: '#20346d',
			600: '#20346d',
			700: '#20346d',
			800: '#20346d',
			900: '#20346d',
			950: '#20346d',
		},
	},
});
